module.exports = __webpack_public_path__ + "img/upperCaseB.4253d8cd.svg";